import "../../styles/Contents.css";

export default function FeesCard({
  badge,
  title,
  className,
  fee,
  days,
  time,
  subjects = [],
  approach = [],
  note,
  ctaText = "Enquire Now"
}) {
  return (
    <div className="page">
      <section className="about-section">
        <div className="fees-card-wrapper">
          <div className="fees-card">

            <span className="fees-badge">{badge}</span>

            <h2>{title}</h2>

            <p><strong>Class:</strong> {className}</p>
            <p><strong>Monthly Fee:</strong> {fee}</p>
            <p><strong>Days:</strong> {days}</p>
            <p><strong>Time:</strong> {time}</p>

            <hr />

            <h3>📚 Subjects Covered</h3>
            <ul className="feature-list">
              {subjects.map((item, index) => (
                <li key={index}> {item}</li>
              ))}
            </ul>

            <hr />

            <h3>🎯 Learning Approach</h3>
            <ul className="feature-list">
              {approach.map((item, index) => (
                <li key={index}> {item}</li>
              ))}
            </ul>

            {note && (
              <p className="note">
                <strong>Note:</strong><br />
                {note}
              </p>
            )}

            <br />

            <a
                href={`https://wa.me/919964585585?text=Hello ACCESS Team, I would like to enquire for ${badge}.`}
                target="_blank"
                rel="noreferrer"
              >
              <button className="fees-cta whatsapp-btn">
                <span className="wa-icon">💬</span>
                  Enquire Now
              </button>
              </a>
          </div>
        </div>
      </section>

    </div>
  );
}
